import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-hire-contact-view-inbound',
  imports: [MatTooltipModule, NgbAlert],
  templateUrl: './hire-contact-view-inbound.component.html',
  styleUrl: './hire-contact-view-inbound.component.scss',
})
export class HireContactViewInboundComponent {

  @Input() candidateDetails: any;
  @Input() calledFrom: string;
  work_email: any[] = [];
  personal_email: any[] = [];
  phones: any[] = [];
  successMessage: string = '';
  errorMessage: string = '';

  ngOnInit(): void {
    this.personal_email = this.candidateDetails?.personal_emails
    this.work_email = this.candidateDetails?.work_emails || [];
    this.phones = this.candidateDetails?.phone_numbers || [];

    console.log(this.phones, 'phones');
  }

  copyToClipboard(content: string) {
    let dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = content;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    this.successMessage = "Contact detail copied successfully"
    setTimeout(() => this.successMessage = '', 3000);
  }

  get noDataFound(){
    return !this.work_email.length && !this.personal_email.length && !this.phones.length;
  }
}
